import { getPhysicalRing } from 'owa-metatags';

/**
 * Determines whether the feedback form should be shown based on the physical ring.
 *
 * The feedback form will be shown if the physical ring is either 'SDFV2' or 'MSIT'.
 *
 * @returns {boolean} - Returns `true` if the physical ring is 'SDFV2' or 'MSIT', `false` otherwise.
 */
export const shouldShowFeedbackForm = () => {
    const physicalRing = getPhysicalRing();
    return physicalRing === 'SDFV2' || physicalRing === 'MSIT';
};
